import React, { useState } from 'react'
import styled from 'styled-components'
import Form from 'react-bootstrap/Form'
import Col from 'react-bootstrap/cjs/Col'
import Button from 'react-bootstrap/cjs/Button'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import FullPageLoading from 'components/FullPageLoading'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
import { _ } from 'utils'
import {
    inviteCrew, selectInviteError, selectInviteRequestStatus, Slugs, staffsSelector
} from './crewSlice'
import { maxStaffSelector } from '../config/fetchBoothSlice'

const S = {
    Form: styled(Form)`
        display: flex;
        flex-direction: row;
        margin: 0 -10px;
    `,
    Input: styled(Form.Control)`
        width: 100%;
    `,
    FormError: styled(Form.Text)`
        color: #F05359;
    `,
}

const AddCrew = () => {
    const params = useParams<Slugs>()
    const dispatch = useDispatch()
    const [email, setEmail] = useState('')
    const inviteError = useSelector(selectInviteError)
    const inviteRequestStatus = useSelector(selectInviteRequestStatus)
    const maxStaff = useSelector(maxStaffSelector)
    const staffs = useSelector(staffsSelector)

    const onSubmit = (e: Event) => {
        e.preventDefault()
        if (!email) { return }
        if (staffs.length >= maxStaff) {
            dispatch(showErrorNotification(_('booth.crew.max_staffs_reached')))
            return
        }
        dispatch(inviteCrew({ email, ...params }))
    }
    return (
        <S.Form onSubmit={onSubmit}>
            <Col xs={12} md={6}>
                <Form.Group>
                    <S.Input
                        type="email"
                        placeholder={_('booth.crew.add.email_placeholder')}
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    { inviteError && (
                        <S.FormError>
                            {inviteError}
                        </S.FormError>
                    )}
                </Form.Group>
            </Col>

            <Col xs="auto">
                <Button type="submit" disabled={!email}>{_('booth.crew.add.submit')}</Button>
            </Col>
            {inviteRequestStatus === 'loading' && <FullPageLoading isAbsolute />}
        </S.Form>
    )
}

export default AddCrew
